import { ContextState, Profile } from './perfil.sat.model';
import { useState } from 'react';
import {
  EnvironmentKeys,
  environmentsCnsGateway,
  environmentsDispersion,
  getCountry,
  isDevMode,
  isLocal
} from '../environments/env';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import base64 from 'base64-js';

const usePerfilSat = (): ContextState => {
  const [inputLogin, setInputLogin] = useState('');
  const [inputType, setInputType] = useState('');
  const [authKey, setAuthKey] = useState('');
  const [userToken, setUserToken] = useState('');
  const [userProfile, setUserProfile] = useState<Profile>({
    profile: { first_name: '', id: '', last_name: '' }
  });
  const [showOtp, setShowOtp] = useState<boolean>(false);
  const [errorMessages, setErrorMessages] = useState<string>('');
  const [otp, setOtp] = useState<any>('');
  const [maskedPhone, setMaskedPhone] = useState<string>('');
  const [errorMessagesOtp, setErrorMessagesOtp] = useState<string>('');
  const [selectedFileCerCSD, setSelectedFileCerCSD] = useState<File | null>(
    null
  );
  const [selectedFileKeyCSD, setSelectedFileKeyCSD] = useState<any>(null);
  const [inputPasswordCSD, setInputPasswordCSD] = useState<string>('');
  const [inputPasswordFiel, setInputPasswordFiel] = useState<string>('');
  const [selectedFileCerFiel, setSelectedFileCerFiel] = useState<File | null>(
    null
  );
  const [selectedFileKeyFiel, setSelectedFileKeyFiel] = useState<any>(null);
  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>(false);
  const [openErrorModal, setOpenErrorModal] = useState<boolean>(false);
  const [errorFilesCode, setErrorFilesCode] = useState<string>('');
  const [requestCSD, setRequestCSD] = useState<boolean>(false);
  const [requestFiel, setRequestFiel] = useState<boolean>(false);
  const [successFielDocuments, setSuccessFielDocuments] = useState<boolean>(
    false
  );
  const [successCsdDocuments, setSuccessCsdDocuments] = useState<boolean>(false);

  const browse = useNavigate();

  const countryCode = (
    isDevMode || isLocal ? 'dev' : getCountry()
  ) as EnvironmentKeys;
  const baseURLCns = environmentsCnsGateway[countryCode].microServices.api;
  const baseURlDispersion =
    environmentsDispersion[countryCode].microServices.api;

  const headers = {
    Authorization: `${userToken}`
  };

  const onFileChange = (e: any, f: any): void => {
    if (e?.target?.files[0]) {
      f(e.target.files[0]);
    }
  };

  const readFileBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const uInt8Array = new Uint8Array(arrayBuffer);
        const base64String: string = base64.fromByteArray(uInt8Array);
        resolve(base64String);
      };
      reader.onerror = () => {
        reject(new Error('Error leyendo el archivo'));
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const Login = () => {
    axios
      .post(
        `${baseURLCns}/rt-auth-helper/courier-web/login/whatsapp/send-code/`,
        {
          phone_or_email: inputLogin
        }
      )
      .then((response) => {
        setAuthKey(response.data.authorization_key);
        setMaskedPhone(response.data.masked_phone);
        setShowOtp(true);
      })
      .catch((response) => {
        setErrorMessages(response.response.data.error.message);
      });
  };

  const OtpValidation = () => {
    axios
      .post(
        `${baseURLCns}/rt-auth-helper/courier-web/login/whatsapp/get-token/`,
        {
          phone_or_email: inputLogin,
          code: otp,
          authorization_key: authKey
        }
      )
      .then((res) => {
        setUserProfile({
          profile: {
            first_name: res.data.profile.first_name,
            id: res.data.profile.id,
            last_name: res.data.profile.last_name
          }
        });
        setUserToken(res.data.user_token);
        browse('/home');
      })
      .catch((res) => {
        setErrorMessagesOtp(res.response.data.error.message);
      });
  };

  const uploadSellosFiles = async () => {
    try {
      if (selectedFileCerCSD && selectedFileKeyCSD) {
        const cerBase64 = await readFileBase64(selectedFileCerCSD);
        const keyBase64 = await readFileBase64(selectedFileKeyCSD);
        axios
          .post(
            `${baseURlDispersion}/heru-tax-file/csd`,
            {
              cer: cerBase64,
              key: keyBase64,
              password: inputPasswordCSD,
              storekeeper_id: userProfile?.profile?.id
            },
            {
              headers: headers
            }
          )
          .then((res) => {
            setErrorFilesCode(res.data.internalError);
            if (res?.data?.internalError) {
              setRequestCSD(true);
              setOpenErrorModal(true);
              setSuccessCsdDocuments(false);
            } else {
              setOpenSuccessModal(true);
              setSuccessCsdDocuments(true);
            }
          })
          .catch((res) => {
            setOpenSuccessModal(true);
            setSuccessCsdDocuments(true);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const uploadFielFiles = async () => {
    try {
      if (selectedFileCerFiel && selectedFileKeyFiel) {
        const cerBase64 = await readFileBase64(selectedFileCerFiel);
        const keyBase64 = await readFileBase64(selectedFileKeyFiel);
        axios
          .post(
            `${baseURlDispersion}/heru-tax-file/fiel`,
            {
              cer: cerBase64,
              key: keyBase64,
              password: inputPasswordFiel,
              storekeeper_id: userProfile?.profile?.id
            },
            {
              headers: headers
            }
          )
          .then((res) => {
            setErrorFilesCode(res.data.internalError);
            if (res?.data?.internalError) {
              setRequestFiel(true);
              setOpenErrorModal(true);
              setSuccessFielDocuments(false);
            } else {
              setOpenSuccessModal(true);
              setSuccessFielDocuments(true);
            }
          })
          .catch(() => {
            setOpenSuccessModal(true);
            setSuccessFielDocuments(true);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    inputLogin,
    setInputLogin,
    inputType,
    setInputType,
    Login,
    OtpValidation,
    showOtp,
    setShowOtp,
    errorMessages,
    setErrorMessages,
    setUserToken,
    userToken,
    otp,
    setOtp,
    userProfile,
    setUserProfile,
    maskedPhone,
    setMaskedPhone,
    errorMessagesOtp,
    setErrorMessagesOtp,
    onFileChange,
    selectedFileCerCSD,
    setSelectedFileCerCSD,
    selectedFileKeyCSD,
    setSelectedFileKeyCSD,
    uploadSellosFiles,
    uploadFielFiles,
    inputPasswordCSD,
    setInputPasswordCSD,
    selectedFileCerFiel,
    setSelectedFileCerFiel,
    selectedFileKeyFiel,
    setSelectedFileKeyFiel,
    inputPasswordFiel,
    setInputPasswordFiel,
    openSuccessModal,
    setOpenSuccessModal,
    openErrorModal,
    setOpenErrorModal,
    errorFilesCode,
    setErrorFilesCode,
    requestCSD,
    setRequestCSD,
    requestFiel,
    setRequestFiel,
    successFielDocuments,
    successCsdDocuments,
    setSuccessFielDocuments,
    setSuccessCsdDocuments
  };
};

export default usePerfilSat;
